/* eslint-disable react/no-array-index-key */

import { Checkbox } from '@mui/material';
import { ShipmentStatus, ClaimType } from '@constants';
import { useNavigate } from 'react-router-dom';
import { SplitLine, Tag } from '../common';
import { Merchandise } from '../merchandise';
import classes from './index.module.css';
import { RemarkPanel } from './remark-panel';
import { WrongInfo } from '../wongInfo';

const HAS_CLAIME_TEXT = 'This item already has a reported issue.';

export const CheckBoxItem = ({
  item,
  handleChange,
  index,
  packageIndex,
  disabled = false,
  selectedItems = [], handleEdit, reasonList = [],
}) => {
  const navigate = useNavigate();
  const {
    reason, claimId, comment, attachments,
  } = item;

  const handleItemClick = (item) => {
    navigate(`../feedback?claimId=${item.claimId}`);
  };

  return (
    <div key={`${item.lineItemId}_${packageIndex}_${index}`}>
      {index === 0 ? null : <SplitLine />}
      <section id="responsive_line_item" className={classes.check_box_item}>
        <Checkbox
          id="responsive_line_item_checkbox"
          color="input"
          onChange={(e) => handleChange(e, packageIndex, index, item)}
          disabled={disabled}
          value={`${item.lineItemId}__${packageIndex}__${index}`}
          checked={selectedItems?.includes(`${item.lineItemId}__${packageIndex}__${index}`)}
        />
        <Merchandise item={item} className={classes.check_merchandise} />
      </section>
      {/* 是否已经申请过 */}
      {claimId
        ? (
          <RemarkPanel
            title={HAS_CLAIME_TEXT}
            btnText="View issue &gt; "
            isShow={false}
            onClick={() => handleItemClick(item)}
          />
        )

        : null}
      {/* 未申请且选择了原因 */}
      {(!claimId && reason) ? (
        <RemarkPanel
          title={reasonList.find((v) => v.value === reason)?.label}
          btnText="Edit"
          files={attachments.map((item) => item.originalFileName)}
          additional={comment}
          onClick={() => handleEdit(item, packageIndex, index)}
        />
      ) : null}
      <div style={{ height: '1px' }}></div>
    </div>
  );
};

export const PackageCheckboxGroup = ({
  packageItem,
  packageIndex,
  onChange,
  selectedItems,
  handleItemEdit,
  reasonList,
  disabled,
  orderNameTitleText, // ordername 可能随着platform变化
  disabledText,
  type,
  needAddShipping,
  haveTheft,
}) => {
  if (!packageItem) {
    return null;
  }
  const { items, status, fulfillmentName } = packageItem;
  const isDelivered = status === ShipmentStatus.Delivered;

  // 如果有不在报案时间内的商品，则提示
  let isShowTips = false;
  if (items.filter((v) => v.isInEffectivePeriod === false)?.length > 0) {
    if (type === ClaimType.Loss && !haveTheft) {
      isShowTips = true;
    } else {
      isShowTips = isDelivered;
    }
  }
  return (
    <>
      {packageIndex === 0 ? null : <SplitLine />}
      {fulfillmentName ? (
        <section className={classes.radio_line}>
          <span className={classes.order_name}>
            <span className={classes.order_name_title}>{orderNameTitleText}</span>
            {fulfillmentName}
          </span>
          {
            status !== ShipmentStatus.Unknown && (
              <Tag
                color={isDelivered ? '#AEE9D1' : '#E4E5E7'}
                text={isDelivered ? 'Delivered' : 'Undelivered'}
              />
            )
          }
          {needAddShipping}
          {
            [ShipmentStatus.UnDelivered, ShipmentStatus.unDelivered, ShipmentStatus.Pending].includes(packageItem.status) ? (
              <WrongInfo name={fulfillmentName} status={status} />
            ) : null
          }
        </section>
      ) : null}
      {isShowTips && (
        <div className={classes.warning_tips_wrapper}>
          <div className={classes.warning_tips}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clipPath="url(#clip0_15292_32678)">
                <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM7.2 4.8C7.2 4.35817 7.55817 4 8 4C8.44183 4 8.8 4.35817 8.8 4.8V8C8.8 8.44183 8.44183 8.8 8 8.8C7.55817 8.8 7.2 8.44183 7.2 8V4.8ZM8 12C8.44183 12 8.8 11.6418 8.8 11.2C8.8 10.7582 8.44183 10.4 8 10.4C7.55817 10.4 7.2 10.7582 7.2 11.2C7.2 11.6418 7.55817 12 8 12Z" fill="#FC9952" />
              </g>
              <defs>
                <clipPath id="clip0_15292_32678">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {disabledText}
          </div>
        </div>
      )}
      {items.map((item, index) => (
        <CheckBoxItem
          key={item.lineItemId + index}
          item={item}
          handleChange={onChange}
          index={index}
          selectedItems={selectedItems}
          packageIndex={packageIndex}
          disabled={!!item.claimId || disabled || item.isInEffectivePeriod === false} // isInEffectivePeriod 代表商品是否在送达有效期内 不在的话，不给报案
          handleEdit={handleItemEdit}
          reasonList={reasonList}
        />
      ))}
    </>
  );
};
